import React from "react";
import { useLocale, useTranslations } from "next-intl";
import CookiePreferencesButton from "@/shared/ui/CookiePreferencesButton";

export function Footer({ isInDashboard = false }: { isInDashboard?: boolean }) {
  const t = useTranslations("Footer");
  const locale = useLocale();
  const localePrefix = locale === "en" ? "/en" : "";

  return (
    <div className="flex w-full justify-center break-keep bg-gray-50">
      <div
        className={`relative w-full max-w-base overflow-hidden py-[50px] ${!isInDashboard && "px-[20px]"}`}
      >
        <div className="flex flex-col justify-between gap-5 sm:flex-row sm:gap-0">
          <div className="inline-flex flex-col items-start justify-start gap-[8px]">
            <div className="inline-flex items-center justify-start gap-2.5">
              <img className="h-[25px] w-auto" src="/images/wilconAI.png" />
            </div>
            <div className="justify-start text-label1 font-[400]">
              {t("윌콘에이아이 주식회사")} | {t("대표 하정은")}
            </div>
            <div className="flex flex-col items-start justify-start gap-[2px] self-stretch text-caption1 font-[400] text-gray-500">
              <div className="justify-start">{t("사업자 등록 번호")}</div>
              <div className="justify-start">{t("통신판매업신고번호")}</div>

              <div className="justify-start text-left">
                {t("주소")} :{" "}
                {t(
                  "경기도 성남시 분당구 서현로180번길 13, 503호 (서현동, 서현프라자)"
                )}
              </div>
              <div>
                <a
                  href={"mailto:wilcon@wilcon.ai"}
                  className="mr-[10px] justify-start text-left text-black"
                >
                  wilcon@wilcon.ai
                </a>
                <span>{t("031-708-8088")}</span>
              </div>
            </div>
            <div className="justify-start text-left text-caption1 font-[400] text-gray-500">
              Copyright © WilconAI Co.,Ltd. All rights reserved.
            </div>
          </div>
          <div className="flex flex-col items-start justify-start text-caption1 text-gray-500">
            <div className={"flex"}>
              <a href={`${localePrefix}/terms`} target={"_blank"}>
                {t("서비스 이용약관")}
              </a>
              &nbsp; | &nbsp;
              <a href={`${localePrefix}/privacy`} target={"_blank"}>
                {t("개인정보 처리방침")}
              </a>
              &nbsp; | &nbsp;
              <a href={`${localePrefix}/cookie`} target={"_blank"}>
                {t("쿠키 정책")}
              </a>
              &nbsp; | &nbsp;
              <a href={`${localePrefix}/refund`} target={"_blank"}>
                {t("환불 정책")}
              </a>
            </div>
            <div>
              <a href={`${localePrefix}/donot`} target={"_blank"}>
                Do Not Sell or Share My Personal Information
              </a>
            </div>
            <div>
              <CookiePreferencesButton />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
